import {observer} from "mobx-react";
import {useParams} from "react-router-dom";
import {useStore} from "../../../stores/Store";
import React, {ChangeEvent, useEffect, useState} from "react";
import Accordion from "../../../models/Accordion";
import Grid from "@mui/material/Unstable_Grid2";
import {
    Box, Button, Checkbox,
    Chip,
    CircularProgress,
    InputAdornment,
    MenuItem,
    Select,
    SelectChangeEvent,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import {Brand} from "../../../models/Brand";
import './AccordionDetailedPage.css'
import {BassType} from "../../../models/BassType";
import AccordionDetailedNavigation from "./AccordionDetailedNavigation";
import ImageSwiper from "../../ImageSwiper/ImageSwiper";
import AccordionDeleteDialog from "../AccordionDeleteDialog";
import AccordionPublishDialog from "../AccordionPublishDialog";
import {EntityStatus} from "../../../models/EntityStatus";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import ImageManager from "../../ImageManager/ImageManager";
import AccordionUnpublishDialog from "../AccordionUnpublishDialog";
import BrandIcon from "../../Misc/BrandIcon/BrandIcon";
import AccordionContactMeDialog from "../AccordionContactMeDialog";

const inputStyle = {
    width: 200
}


export default observer(function AccordionDetailedPage(){
    const { id } = useParams();
    const [nId, setNid] = useState<number | undefined>();
    const { AccordionStore, LanguageStore, UserStore,  } = useStore();
    const {currentLanguageMessages} = LanguageStore;
    const {accordions, isLoading, update, attributeIsLoading} = AccordionStore
    const [accordion, setAccordion] = useState<Accordion | undefined>();

    useEffect(() => {
        setNid(!!id ? parseInt(id) : undefined);
    }, [id]);

    useEffect(() => {
        setAccordion(accordions.find(a => a.id === nId));
    }, [accordions, nId])

    const renderValueTextField = (value: string | number, datatype: 'string' | 'int' | 'float', name: string, unit: string = '', loggedOutValue?: string) => (UserStore.isLoggedIn) ?
        <TextField
            value={(value) ? value : ''}
            onChange={onChangeText(datatype)}
            size={'small'}
            variant={'outlined'}
            name={name}
            type={(typeof value === 'number') ? 'number' : 'text'}
            InputProps={{
                endAdornment: <InputAdornment position="end">
                    {attributeIsLoading.get(name) &&  <CircularProgress color={'secondary'} size={16} sx={{mr: 2}}/>}
                    {unit}
                </InputAdornment>,
            }}
            disabled={attributeIsLoading.get(name)}
            sx={inputStyle}
            onBlur={() => {
                accordion && update(accordion, name)
            }}
            onKeyUp={(event: any) => { if(event.keyCode === 13 && accordion) update(accordion, name)  }}

        /> : (loggedOutValue) ? loggedOutValue : value

    const renderValueSelect = (selectedValue: Brand | BassType | string, name: string, options: {value: BassType | Brand | string, name: string}[], selectedValueName?: string) => (UserStore.isLoggedIn) ?
        <>
            <Select
                value={selectedValue}
                onChange={onChangeSelect}
                disabled={attributeIsLoading.get(name)}
                name={name}
                sx={inputStyle}
                size={'small'}
            >
                {
                    options.map(option => <MenuItem key={option.value} value={option.value}>{option.name}</MenuItem>)
                }
            </Select>
        </> : (selectedValueName) ? selectedValueName : selectedValue

    const renderValueCheckbox = (value: boolean, name: string) =>
        <Checkbox
            checked={value}
            name={name}
            onChange={onChangeCheckbox}
            disabled={attributeIsLoading.get(name) || !UserStore.isLoggedIn}
        />


    const onChangeText = (datatype: 'string' | 'int' | 'float') => (event: any) => {
        if(!accordion) return;
        setAccordion({...accordion,
            [event.target.name] :
                (datatype === 'int') ? (!isNaN(parseInt(event.target.value))) ? parseInt(event.target.value) : 0 :
                (datatype === 'float') ? (!isNaN(parseFloat(event.target.value))) ? parseFloat(event.target.value) : 0 :
                event.target.value
        })
    }

    const onChangeSelect = (event: SelectChangeEvent) => {
        if(!accordion) return;
        const newAccordion = {...accordion, [event.target.name]: event.target.value}
        setAccordion(newAccordion)
        update(newAccordion, event.target.name);
    }

    const onChangeCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
        if(!accordion) return;
        const newAccordion = {...accordion, [event.target.name]: event.target.checked}
        setAccordion(newAccordion)
        update(newAccordion, event.target.name);
    }

    const onChangeReeds = (event: SelectChangeEvent) => {
            if(!accordion) return;
            //@ts-ignore
            let temp: Accordion = new Object({...accordion})
            temp.tam = false;
            temp.fam = false;
            temp.turbo = false;
            temp.durall = false;
            //@ts-ignore
            if(event.target.value !== '') temp[event.target.value] = true;
            setAccordion(temp);
            update(temp, 'tam')
    }

    const renderPage = () =>
        (isLoading) ?
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100vh" }}
            >
                <CircularProgress color={'secondary'} />
            </Box> :
        (accordion) ?
        <Grid container spacing={8} sx={{m: 2}}>
            <Grid xs={12} md={4} order={{xs: 2, md: 1}}>
                <AccordionDetailedNavigation accordion={accordion} />
            </Grid>
            <Grid container xs={12} md={8} order={{xs: 1, md: 2}}>
                <Grid xs={12}>
                    <ImageSwiper accordion={accordion} />
                </Grid>
                <Grid container xs={12} sx={{justifyContent: 'space-between'}}>
                    <Grid sx={{display: 'flex', justifyContent: 'center'}}>
                        <BrandIcon
                            brand={accordion.brand}
                            style={{width: '30px', height: '30px', marginTop: (UserStore.isLoggedIn) ? '5px' : ''}}
                        />
                        <Typography sx={{ml: 4}} variant={'h5'}>{renderValueTextField(accordion.name, 'string', 'name')}</Typography>
                    </Grid>
                    <Grid>
                        <AccordionContactMeDialog accordion={accordion} />
                    </Grid>
                </Grid>
                
                { (accordion.status === EntityStatus.draft) ?  <Grid xs={12} textAlign={'center'}><Chip label={'Draft'} color={'secondary'} icon={<ModeEditIcon />} /></Grid> : null }
                {
                    UserStore.isLoggedIn &&
                    <Grid xs={12} sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Box><AccordionDeleteDialog accordion={accordion} /></Box>
                        { accordion.status === EntityStatus.draft ?
                            <Box><AccordionPublishDialog accordion={accordion}/></Box> :
                            <Box><AccordionUnpublishDialog accordion={accordion} /></Box>
                        }
                        <Box><ImageManager accordion={accordion} /></Box>
                    </Grid>
                }
                <Grid sx={{display: 'flex', flexDirection: 'column', textAlign: 'center'}} xs={12}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={2}><Typography fontWeight={'bold'}>{currentLanguageMessages.AccordionsPage.Filter.generalCategoryTitle}</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.brandTitle}</TableCell>
                                <TableCell>{
                                    renderValueSelect(
                                        accordion.brand,
                                        'brand',
                                        [
                                            { name: 'Pigini', value: Brand.Pigini},
                                            { name: 'Excelsior', value: Brand.Excelsior},
                                            { name: 'Serenellini', value: Brand.Serenellini },
                                            { name: 'Tula', value: Brand.Tula },
                                            { name: 'Other', value: Brand.Other},
                                        ]
                                    )
                                }</TableCell>
                            </TableRow>
                            {
                                UserStore.isLoggedIn ?
                                    <>
                                        <TableRow>
                                            <TableCell>{ currentLanguageMessages.AccordionsPage.Filter.Condition.used }</TableCell>
                                            <TableCell>
                                                { renderValueCheckbox(accordion.used, 'used') }
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{ currentLanguageMessages.AccordionsPage.Filter.isRental }</TableCell>
                                            <TableCell>
                                                { renderValueCheckbox(accordion.rental, 'rental') }
                                            </TableCell>
                                        </TableRow>
                                    </>
                                : null
                            }

                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.BassType.title}</TableCell>
                                <TableCell>
                                    { renderValueSelect(
                                        accordion.bassType,
                                        'bassType',
                                        [
                                            { name: currentLanguageMessages.AccordionsPage.Filter.BassType.convertor, value: BassType.Convertor },
                                            { name: currentLanguageMessages.AccordionsPage.Filter.BassType.standard, value: BassType.Standard }
                                        ],
                                        (accordion.bassType === BassType.Convertor) ?
                                            currentLanguageMessages.AccordionsPage.Filter.BassType.convertor :
                                            currentLanguageMessages.AccordionsPage.Filter.BassType.standard
                                    ) }
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.Height.title}</TableCell>
                                <TableCell>{renderValueTextField(accordion.height, 'float', 'height', 'cm')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.Width.title}</TableCell>
                                <TableCell>{renderValueTextField(accordion.width, 'float', 'width', 'cm')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.Weight.title}</TableCell>
                                <TableCell>{renderValueTextField(accordion.weight, 'float', 'weight', 'kg')}</TableCell>
                            </TableRow>
                            {
                                (UserStore.isLoggedIn) ?
                                    <TableRow>
                                        <TableCell>{currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.title}</TableCell>
                                        <TableCell>
                                            <Select
                                                value={(accordion.tam) ? 'tam' : accordion.fam ? 'fam' : accordion.turbo ? 'turbo' : accordion.durall ? 'durall' : ''}
                                                onChange={onChangeReeds}
                                                sx={inputStyle}
                                                size={'small'}
                                                name={'tam'}
                                                disabled={attributeIsLoading.get('tam')}
                                            >
                                                <MenuItem value={''}>None</MenuItem>
                                                <MenuItem value={'tam'}>{currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.tam}</MenuItem>
                                                <MenuItem value={'fam'}>{currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.fam}</MenuItem>
                                                <MenuItem value={'turbo'}>{currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.turbo}</MenuItem>
                                                <MenuItem value={'durall'}>{currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.durall}</MenuItem>
                                            </Select>
                                        </TableCell>
                                    </TableRow>
                                :
                                    (accordion.fam || accordion.tam || accordion.turbo || accordion.durall) ?
                                        <TableRow>
                                            <TableCell>{currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.title}</TableCell>
                                            <TableCell>
                                                {
                                                    (accordion.tam) ? currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.tam :
                                                        (accordion.fam) ? currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.fam :
                                                            (accordion.durall) ? currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.durall :
                                                                (accordion.turbo) ? currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.turbo :
                                                                    null
                                                }
                                            </TableCell>
                                        </TableRow> :
                                        null
                            }
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <Typography fontWeight={'bold'}>{currentLanguageMessages.AccordionsPage.Filter.leftHandCategoryTitle}</Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.Rows.title}</TableCell>
                                <TableCell>{renderValueTextField(accordion.rowsButLeft, 'int', 'rowsButLeft')}</TableCell>
                            </TableRow>
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <Typography sx={{fontWeight: 'bold', mt: 2}}>{currentLanguageMessages.AccordionsPage.Filter.standardBassCategoryTitle}</Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.standardBassCategoryTitle}</TableCell>
                                <TableCell>{renderValueTextField(accordion.sbLeft, 'int', 'sbLeft')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.RegisterSb.title}</TableCell>
                                <TableCell>{renderValueTextField((accordion.registerSbLeft) ? accordion.registerSbLeft : '', 'string', 'registerSbLeft')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.StandardBassChorus.title}</TableCell>
                                <TableCell>{renderValueTextField((accordion.chorusSb) ? accordion.chorusSb : 0, 'int', 'chorusSb')}</TableCell>
                            </TableRow>
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <Typography sx={{fontWeight: 'bold', mt: 2}}>{currentLanguageMessages.AccordionsPage.Filter.freeBassCategoryTitle}</Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.FreeBassNotes.title}</TableCell>
                                <TableCell>
                                    {
                                        (UserStore.isLoggedIn) ?
                                            <Box sx={{display: 'flex', justifyContent: 'space-between', p: 0, m: 0}}>
                                                    <TextField
                                                        size={'small'}
                                                        value={accordion.fbLeft}
                                                        onChange={onChangeText('int')}
                                                        name={'fbLeft'}
                                                        label={currentLanguageMessages.GeneralComponentLabels.notes}
                                                        onBlur={() => accordion && update(accordion, 'fbLeft')}
                                                        onKeyUp={(event: any) => { if(event.keyCode === 13 && accordion) update(accordion, 'fbLeft')  }}
                                                    />
                                                    <TextField
                                                        size={'small'}
                                                        value={accordion.rangeFbFrom}
                                                        onChange={onChangeText('string')}
                                                        name={'rangeFbFrom'}
                                                        label={currentLanguageMessages.GeneralComponentLabels.from}
                                                        onBlur={() => accordion && update(accordion, 'rangeFbFrom')}
                                                        onKeyUp={(event: any) => { if(event.keyCode === 13 && accordion) update(accordion, 'rangeFbFrom')  }}
                                                    />
                                                    <TextField
                                                        size={'small'}
                                                        value={accordion.rangeFbTo}
                                                        onChange={onChangeText('string')}
                                                        name={'rangeFbTo'}
                                                        label={currentLanguageMessages.GeneralComponentLabels.to}
                                                        onBlur={() => accordion && update(accordion, 'rangeFbTo')}
                                                        onKeyUp={(event: any) => { if(event.keyCode === 13 && accordion) update(accordion, 'rangeFbTo')  }}
                                                    />
                                            </Box> :
                                            <>{accordion.fbLeft} {accordion.rangeFbFrom} / {accordion.rangeFbTo}</>
                                    }

                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.RegisterSb.title}</TableCell>
                                <TableCell>{renderValueTextField((accordion.registerFbLeft) ? accordion.registerFbLeft : '', 'string', 'registerFbLeft')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.ChorusFb.title}</TableCell>
                                <TableCell>{renderValueTextField((accordion.chorusFb) ? accordion.chorusFb : '', 'string', 'chorusFb')}</TableCell>
                            </TableRow>
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <Typography fontWeight={'bold'}>{currentLanguageMessages.AccordionsPage.Filter.rightHandCategoryTitle}</Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.title}</TableCell>
                                <TableCell>
                                    {
                                        renderValueSelect(
                                            accordion.keysOrBut,
                                            'keysOrBut',
                                            [
                                                { name: currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.keys, value: 'piano' },
                                                { name: currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.buttons, value: 'button' }
                                            ],
                                            (accordion.keysOrBut === 'piano') ?
                                                currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.keys :
                                                currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.buttons
                                        )
                                    }
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{(accordion.keysOrBut === 'piano') ? currentLanguageMessages.AccordionsPage.Filter.RightNotesPiano.title : currentLanguageMessages.AccordionsPage.Filter.RightHandButtons.title}</TableCell>
                                <TableCell>
                                    {
                                        (UserStore.isLoggedIn) ?
                                            (accordion.keysOrBut === 'button') ?
                                                <Box sx={{display: 'flex', justifyContent: 'space-between', p: 0, m: 0}}>
                                                    <TextField
                                                        size={'small'}
                                                        value={(accordion.buttonRight) ? accordion.buttonRight : ''}
                                                        onChange={onChangeText('int')}
                                                        name={'buttonRight'}
                                                        label={currentLanguageMessages.GeneralComponentLabels.notes}
                                                        onBlur={() => accordion && update(accordion, 'buttonRight')}
                                                        onKeyUp={(event: any) => { if(event.keyCode === 13 && accordion) update(accordion, 'buttonRight')  }}
                                                    />
                                                    <TextField
                                                        size={'small'}
                                                        value={(accordion.buttonRangeRight) ? accordion.buttonRangeRight : ''}
                                                        onChange={onChangeText('int')}
                                                        name={'buttonRangeRight'}
                                                        label={currentLanguageMessages.GeneralComponentLabels.range}
                                                        onBlur={() => accordion && update(accordion, 'buttonRangeRight')}
                                                        onKeyUp={(event: any) => { if(event.keyCode === 13 && accordion) update(accordion, 'buttonRangeRight')  }}
                                                    />
                                                    <TextField
                                                        size={'small'}
                                                        value={(accordion.rangeRightFrom) ? accordion.rangeRightFrom : ''}
                                                        onChange={onChangeText('string')}
                                                        name={'rangeRightFrom'}
                                                        label={currentLanguageMessages.GeneralComponentLabels.from}
                                                        onBlur={() => accordion && update(accordion, 'rangeRightFrom')}
                                                        onKeyUp={(event: any) => { if(event.keyCode === 13 && accordion) update(accordion, 'rangeRightFrom')  }}
                                                    />
                                                    <TextField
                                                        size={'small'}
                                                        value={(accordion.rangeRightTo) ? accordion.rangeRightTo : ''}
                                                        onChange={onChangeText('string')}
                                                        name={'rangeRightTo'}
                                                        label={currentLanguageMessages.GeneralComponentLabels.to}
                                                        onBlur={() => accordion && update(accordion, 'rangeRightTo')}
                                                        onKeyUp={(event: any) => { if(event.keyCode === 13 && accordion) update(accordion, 'rangeRightTo')  }}
                                                    />
                                                </Box> :
                                                <Box sx={{display: 'flex', justifyContent: 'space-between', p: 0, m: 0}}>
                                                    <TextField
                                                        size={'small'}
                                                        value={(accordion.keysPianoRight) ? accordion.keysPianoRight : ''}
                                                        onChange={onChangeText('int')}
                                                        name={'keysPianoRight'}
                                                        label={currentLanguageMessages.GeneralComponentLabels.notes}
                                                        onBlur={() => accordion && update(accordion, 'keysPianoRight')}
                                                        onKeyUp={(event: any) => { if(event.keyCode === 13 && accordion) update(accordion, 'keysPianoRight')  }}
                                                    />
                                                    <TextField
                                                        size={'small'}
                                                        value={(accordion.rangeRightFrom) ? accordion.rangeRightFrom : ''}
                                                        onChange={onChangeText('string')}
                                                        name={'rangeRightFrom'}
                                                        label={currentLanguageMessages.GeneralComponentLabels.from}
                                                        onBlur={() => accordion && update(accordion, 'rangeRightFrom')}
                                                        onKeyUp={(event: any) => { if(event.keyCode === 13 && accordion) update(accordion, 'rangeRightFrom')  }}
                                                    />
                                                    <TextField
                                                        size={'small'}
                                                        value={(accordion.rangeRightTo) ? accordion.rangeRightTo : ''}
                                                        onChange={onChangeText('string')}
                                                        name={'rangeRightTo'}
                                                        label={currentLanguageMessages.GeneralComponentLabels.to}
                                                        onBlur={() => accordion && update(accordion, 'rangeRightTo')}
                                                        onKeyUp={(event: any) => { if(event.keyCode === 13 && accordion) update(accordion, 'rangeRightTo')  }}
                                                    />
                                                </Box>
                                            :
                                            (accordion.keysOrBut === 'piano') ?
                                                <span>{accordion.keysPianoRight} {accordion.rangeRightFrom} / {accordion.rangeRightTo}</span> :
                                                <span>{accordion.buttonRight} ({accordion.buttonRangeRight} {accordion.rangeRightFrom} / {accordion.rangeRightTo})</span>
                                    }
                                </TableCell>
                            </TableRow>
                            {
                                (accordion.keysOrBut === 'button') ?
                                    <TableRow>
                                        <TableCell>{currentLanguageMessages.AccordionsPage.Filter.Rows.title}</TableCell>
                                        <TableCell>{renderValueTextField((accordion.rowsButRight) ? accordion.rowsButRight : 0, 'int', 'rowsButRight')}</TableCell>
                                    </TableRow> :
                                    null
                            }
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.ChorusRight.title}</TableCell>
                                <TableCell>{renderValueTextField((accordion.chorusRight) ? accordion.chorusRight : 0, 'int', 'chorusRight')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.CassottoRight.title}</TableCell>
                                <TableCell>{renderValueTextField((accordion.casRight) ? accordion.casRight : 0, 'int', 'casRight')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.RegisterRight.title}</TableCell>
                                <TableCell>{renderValueTextField((accordion.registerRight) ? accordion.registerRight : '', 'string', 'registerRight')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{currentLanguageMessages.AccordionsPage.Filter.ChinSwitches.title}</TableCell>
                                <TableCell>{renderValueTextField((accordion.chinSwitches) ? accordion.chinSwitches : 0, 'int', 'chinSwitches')}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Grid>
            </Grid>
        </Grid> :
        <Grid container sx={{justifyContent: 'center', pt: 8}}>
            <Grid>
                <Typography variant={'h4'}>{ currentLanguageMessages.AccordionsPage.accordionNotFoundText }</Typography>
            </Grid>
        </Grid>

    return renderPage()
})